import { ContextResultsForState, GetterSetter, makeContextFor } from "@me8eon/context";
import React, { ReactNode, useContext, useEffect, useState } from "react";
import { useThrowError } from "@me8eon/throw_error";
import { capitalizeFirstLetter } from "@me8eon/string_utils";
import { getWorkingStorage } from "@me8eon/react_storage";

export interface IStorage {
    getItem(key: string): string | null;
    setItem(key: string, value: string): void;
    removeItem(key: string): void;

    type: string;
}


export const mapStorageImplementation = (store: Map<string, string> = new Map<string, string>()): IStorage => {
    return {
        type: "mapStorage",
        getItem: (key: string): string | null => store.has(key) ? store.get(key)! : null,
        setItem: (key: string, value: string): void => {store.set(key, value);},
        removeItem: (key: string): void => {store.delete(key);},
        store,
    } as IStorage;
};

// --- Detection Function ---
// Writes a random value to a test key, checks if it can read it back correctly, and then removes it.
export const isStorageWorking = (storage: IStorage): boolean => {
    const testKey = "__storage_test__";
    const testValue = Math.random().toString();
    try {
        storage.setItem(testKey, testValue);
        const working = storage.getItem(testKey) === testValue;
        storage.removeItem(testKey);
        return working;
    } catch (e) {
        return false;
    }
};

